import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import Config from '../../../Config';
import AddressForm from '../SaleJetBlock/Partials/AddressForm/AddressForm';
import CheckFiberStatus from '../SaleJetBlock/Partials/CheckFiberStatus/CheckFiberStatus';
import EntryList from '../SaleJetBlock/Partials/EntryList/EntryList';
import FoundFiberSuccess from '../SaleJetBlock/Partials/FoundFiberSuccess/FoundFiberSuccess';
import LeadPage from './leadPage';
import { navigateToUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { initBlock, setSelectedAddress, setSelectedEntry, getAddressEntries, checkFiberAddressInfraStructure, checkWhatsAppActivity, reportDWH } from './checkFiberInfrastructureSlice';
import { gtag4 } from '../../../utilities/analytics/tracking';

const CheckFiberInfrastructure = (props) => {
    const fiberList = ['FB', 'BF', 'BC'];
    const [step, setStep] = useState('AddressForm');
    const [entries, setEntries] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [backgroundStyle, setBackgroundStyle] = useState(null);

    let currentPageView = null;
    let isDisplayButton = (step == 'AddressForm' || step == 'EntryList');

    useEffect(() => {
        props.initBlock({ checkFiberInfrastructureBlock: props.iContent });

        let style = {};
        const backgroundColor = props.iContent.blockBackgroundColor?.value;
        const backgroundImage = props.iContent.blockBackgroundImage?.value?.url;
        if (backgroundColor) {
            style.backgroundColor = backgroundColor;
        }
        if (backgroundImage) {
            style.backgroundImage = `url(${Config.epiBaseUrl + backgroundImage})`;
            style.backgroundRepeat = 'no-repeat';
            style.backgroundPosition = 'center center';
        }
        setBackgroundStyle(style);
        props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Address Check Page Displayed' });
        gtag4({ event: 'SearchAddressBox_Imp', action: 'Imp' });
    }, []);

    let title = '';
    let subTitle = '';

    switch (step) {
        case 'AddressForm':
            currentPageView = <AddressForm isSubmit={isSubmit} onSubmit={handlePageValidate} selectedAddress={props.selectedAddress} />;
            title = props.iContent.title.value
            break;
        case 'CheckFiberStatus':
            currentPageView = <CheckFiberStatus selectedAddress={props.selectedAddress} />;
            break;
        case 'EntryList':
            currentPageView = <EntryList onSubmit={isSubmit} onValid={handlePageValidate} entries={entries} setSelectedEntry={handleSelectedEntry} selectedEntry={props.selectedEntry} />;
            title = 'שמנו לב שיש בבניין שלך יותר מכניסה אחת';
            subTitle = 'מהי הכניסה שלך?';
            break;
        case 'FoundFiberSuccess':
            currentPageView = <FoundFiberSuccess onSubmit={isSubmit} onValid={handlePageValidate} selectedAddress={props.selectedAddress} />;
            break;
        case 'LeadPage':
            {
                const isInsideIframe = !!props.iContent.isInsideIframe?.value;
                if (isInsideIframe) {
                    postDataToParent(false);
                }
                currentPageView = <LeadPage />;
                break;
            }
    }


    return (
        <div className='check-fiber-infrastructure' style={backgroundStyle}>

            {
                title &&
                <div className='page-headline-wrapper'>
                    <div className='page-title'> {title} </div>
                    {subTitle && <div className='page-sub-title'> {subTitle} </div>}
                </div>
            }

            <div className='page-content'>

                <form noValidate id='checkFiberInfrastructure' onSubmit={handleSubmit}>
                    {currentPageView}

                    {
                        isDisplayButton &&
                        <div className='button-wrapper'>
                            <BtnSubmit
                                isBusiness={false}
                                text={props.iContent.buttonText.value}
                                onclick={handleOnContinue}
                                formid='checkFiberInfrastructure'
                                isDisplayArrows={false}
                                isDisplayWhatsAppIcon={false}
                            />
                        </div>
                    }

                </form>

            </div>

        </div>
    );

    function goToSale() {
        const isInsideIframe = !!props.iContent.isInsideIframe?.value;
        if (isInsideIframe) {
            postDataToParent(true);
            return;
        }
        navigateToUrl(props.iContent.urlToSale?.value);
    }

    function postDataToParent(hasFiber) {
        var pageData = {
            eventType: 'checkFiberResult',
            hasFiber: hasFiber,
            addres: {
                streetName: props.selectedAddress.streetName,
                cityName: props.selectedAddress.cityName,
                home: props.selectedAddress.home,
            }
        };
        parent.postMessage(pageData, '*');
    }

    async function getAddressEntries() {
        const response = await props.getAddressEntries();
        const entryList = response.payload?.Body?.entryList;
        if (entryList != undefined && entryList?.length > 0) {
            setEntries(entryList);
            if (entryList.length == 1) {
                handleSelectedEntry(entryList[0]);
                setStep('CheckFiberStatus');
                getFiberAddressInfraStructure();
            } else {
                setStep('EntryList');
            }
        }
        else {
            await props.checkWhatsAppActivity();
            setStep('LeadPage');
            props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'There is no entries' });
        }
    }

    async function getFiberAddressInfraStructure() {
        const response = await props.checkFiberAddressInfraStructure();
        const entryList = response.payload?.Body?.entryList;
        if (entryList != undefined && entryList?.length > 0) {
            const selected_entry = entryList.length == 1 ? entryList[0] : entryList.find(x => x.entry == props.selectedEntry.entry);
            handleSelectedEntry(selected_entry);
            if (fiberList.includes(selected_entry.infrastructure)) {
                setStep('FoundFiberSuccess');
                props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Fiber Connected There' });
            } else {
                await props.checkWhatsAppActivity();
                setStep('LeadPage');
                props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Fiber Not Connected There' });
            }
        } else {
            await props.checkWhatsAppActivity();
            setStep('LeadPage');
            props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Fiber Not Connected There' });
        }
    }

    function handlePageValidate(data) {
        setIsSubmit(false);
        switch (step) {
            case 'AddressForm':
                if (data.isValid) {
                    props.setSelectedAddress(data.selectedAddress);
                    props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Address Check Button Clicked' });
                    gtag4({ event: 'SearchAddressBox_CheckButton', action: 'CheckButton', button: props.iContent.buttonText.value, content: data.selectedAddress.cityName, place: data.selectedAddress.streetName + ' ' + data.selectedAddress.home });
                    getAddressEntries();
                }
                break;
            case 'EntryList':
                if (data.valid) {
                    props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Entrance Popup Button Clicked' });
                    setStep('CheckFiberStatus');
                    getFiberAddressInfraStructure();
                }
                break;
            case 'FoundFiberSuccess':
                goToSale();
                break;
        }
    }

    function handleSelectedEntry(entry) {
        props.setSelectedEntry(entry);
    }

    function handleOnContinue() {
        setIsSubmit(true);
    }

    function handleSubmit(event) {
        event.preventDefault();
    }
};

const mapStateToProps = (state) => {
    return {
        selectedEntry: state.checkFiberInfrastructureBlock.addressPage.selectedEntry,
        selectedAddress: state.checkFiberInfrastructureBlock.addressPage.selectedAddress,
    };
};

const mapDispatchToProps = {
    initBlock,
    setSelectedAddress,
    getAddressEntries,
    checkFiberAddressInfraStructure,
    setSelectedEntry,
    checkWhatsAppActivity,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckFiberInfrastructure);
